import { render, staticRenderFns } from "./LeaveTeam.vue?vue&type=template&id=267e6c46&scoped=true"
import script from "./LeaveTeam.vue?vue&type=script&lang=js"
export * from "./LeaveTeam.vue?vue&type=script&lang=js"
import style0 from "./LeaveTeam.vue?vue&type=style&index=0&id=267e6c46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e6c46",
  null
  
)

export default component.exports